import * as React from 'react';
import { InputNumber, Form } from 'antd';
import styles from './inputNumber.module.scss';
import cs from 'classnames';

const CustomInputNumber = ({
  children,
  message,
  className,
  rules,
  name,
  label,
  isVertical = true,
  onChange,
  placeholder,
  maxLength,
  ...rest
}) => {
  return (
    <>
      <Form.Item
        required={false}
        className={cs(styles.inputWrapper, { [styles.inputVerticalWrapper]: isVertical })}
        label={label}
        onChange={onChange}
        name={name}
        rules={rules}
        labelAlign={isVertical ? 'left' : 'right'}
      >
        <InputNumber
          className={cs(styles.inputClass, { [className]: className })}
          name={name}
          placeholder={placeholder}
          min={1}
          max={maxLength ? maxLength : 100}
          controls={false}
          {...rest}
        />
      </Form.Item>
    </>
  );
};
export default CustomInputNumber;
